
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { GetLessonsResponseDto } from "../dtos/get-lessons.response.dto";
import { URLS } from "../../constants/constants";
import { AuthService } from "../../../common/services/auth.service";
import { GetCourseCodeAvailabilityResponseDto } from "../../../common/dtos/get-course-code-availability.response.dto";
import { LessonsDto } from "../dtos/lessons.dto";
import { TableEventData } from "../../../common/types/table.event.data.type";
import { CreateLessonDto } from "../dtos/create-lesson.dto";



@Injectable()
export class LessonsService {
private http = inject(HttpClient);
private authService = inject(AuthService)
    
    getLessons(tableEventData:TableEventData) : Promise<GetLessonsResponseDto>{
        const {skip,limit,sortField,sortOrder,searchQuery} = tableEventData;
        let url = `${URLS.LESSONS_API}?skip=${skip}&limit=${limit}&sortField=${sortField}&sortOrder=${sortOrder}`;
        if (searchQuery) {
            url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
        }
        return firstValueFrom(this.http.get<GetLessonsResponseDto>(url, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
    checkAvailabilityFor(codes:{courseCodes:string[]}):Promise<GetCourseCodeAvailabilityResponseDto>{
        const url = `${URLS.LESSONS_API}/check-availability`;
        return firstValueFrom(this.http.post<GetCourseCodeAvailabilityResponseDto>(url, codes, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
    createLessons(lessons:Array<CreateLessonDto>){
        const url = `${URLS.LESSONS_API}`;
        return firstValueFrom(this.http.post(url, lessons, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
    toggleCanPostGradeToRLMS(lesson:LessonsDto,canPostGradeToRLMSValue:boolean){
        const url = `${URLS.LESSONS_API}/${lesson.id}/canPostGradeToRLMS/${canPostGradeToRLMSValue}`;
            return firstValueFrom(this.http.patch(url, lesson, {
                headers: this.authService.getAuthHeaders()
        }));         
    }
    getLesson(courseCode:string){
        const url = `${URLS.LESSONS_API}/${courseCode}`;
        return firstValueFrom(this.http.get(url));
       
    }
}